const initialState = {
    setlists: [],
    status: "idle",
    cachingProgress: null
  };

export default initialState;